import { render, staticRenderFns } from "./uwesQuestion.vue?vue&type=template&id=56b5a0b5&scoped=true"
import script from "./uwesQuestion.vue?vue&type=script&lang=js"
export * from "./uwesQuestion.vue?vue&type=script&lang=js"
import style0 from "./uwesQuestion.vue?vue&type=style&index=0&id=56b5a0b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5a0b5",
  null
  
)

export default component.exports